<template>
  <protected-pages-layout>
  <div class="wrapper">
    <!-- <navbar></navbar> -->
    <div
      v-if="!pageReady"
      class="d-flex justify-content-center align-items-center m-5"
    >
      <div
        class="spinner-border text-dark"
        style="width: 7.5rem; height: 7.5rem"
        role="status"
      >
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div v-else>
      <div class="row" style="margin: 30px 0">
        <div class="col-md-10 offset-md-1">
          <form>
            <div class="row">
              <div class="col" v-if="isRoleOther">
                <label>Team</label>
                <select
                  v-model="currentTeam"
                  class="form-select"
                  @change="
                    dataChangement();
                    reloadCurrUserCampaign++;
                  "
                >
                  <option
                    :key="index"
                    :value="team"
                    v-for="(team, index) in teams"
                  >
                  <!-- {{console.log("team: ", team.Team)}} -->
                  {{ team.Team.Name }}
                  </option>
                </select>
              </div>
              <div class="col" v-if="isRoleOther">
                <label>Team Member</label>
                <select
                  v-model="parameters.teamMember"
                  class="form-select"
                  @change="
                    dataChangement();
                    reloadCurrUserCampaign++;
                  "
                >
                  <option
                    :key="index"
                    :value="member"
                    v-for="(member, index) in currentTeam.Members"
                  >
                  <!-- {{console.log("member: ", member)}} -->
                    {{ member.Name }} 
                  </option>
                </select>
              </div>
              <div class="col" v-else>
                <label>Team Member</label>
                <select
                  v-model="parameters.teamMember"
                  class="form-select"
                  @change="
                    dataChangement();
                    reloadCurrUserCampaign++;
                  "
                >
                  <option
                    :key="index"
                    :value="member"
                    v-for="(member, index) in teamMembers"
                  >
                  <!-- {{console.log("teamMembers: ", teamMembers)}} -->
                    {{ member.Name }}
                  </option>
                </select>
              </div>
              <div class="col">
                <label>Report Type</label>
                <select
                  v-model="parameters.leadReportType"
                  class="form-select"
                  @change="
                    dataChangement();
                    reloadCurrUserCampaign++;
                  "
                >
                  <option
                    :key="index"
                    :value="reportType.value"
                    v-for="(reportType, index) in personalReportTypes"
                  >
                    {{ reportType.name }}
                  </option>
                </select>
              </div>
              <div class="col">
                <label>Period</label>
                <select
                  v-model="parameters.period"
                  class="form-select"
                  @change="
                    dataChangement();
                    reloadCurrUserCampaign++;
                  "
                >
                  <option
                    :key="index"
                    :value="period.value"
                    v-for="(period, index) in periods"
                  >
                    {{ period.name }}
                  </option>
                </select>
              </div>
              <div class="col" v-if="parameters.leadReportType !== 'client'">
                <label>Breakdown</label>
                <select
                  v-model="parameters.breakdown"
                  class="form-select"
                  @change="
                    dataChangement();
                    reloadCurrUserCampaign++;
                  "
                  id="breakdown"
                >
                  <option
                    :key="index"
                    :value="breakdown.value"
                    v-for="(breakdown, index) in breakdowns"
                  >
                    {{ breakdown.name }}
                  </option>
                </select>
              </div>
              <div class="col" v-if="parameters.leadReportType === 'client'">
                <label>Offset</label><br />
                <select
                  v-model="parameters.offset"
                  class="form-select"
                  @change="
                    dataChangement();
                    reloadCurrUserCampaign++;
                  "
                  id="offset"
                >
                  <option
                    :key="index"
                    :value="offset"
                    v-for="(offset, index) in favoritesPages"
                  >
                    {{ offset }}
                  </option>
                </select>
              </div>
            </div>
          </form>
        </div>
      </div>
      <v-row class="d-flex ps-16" style="width: 100%">
        <v-col cols="12" md="6">
          <v-dialog v-model="showTotalDetails" persistent max-width="50vw" class="d-flex justify-center align-center">
            <template v-slot:activator="{ props: activatorProps }">
              <v-card class="border-0 shadow card-dashboard">
                <v-card-body
                  ref="totalCard"
                  id="totalCard"
                  @click="
                    calculateTotals();
                    showTotalDetails = true;
                  "
                  v-bind="activatorProps"
                  class="d-flex flex-column align-center justify-center"
                >
                  <h6 class="card-subtitle mb-2 text-muted">Total</h6>
                  <v-skeleton-loader
                    v-if="loadingNewDataReady"
                    type="text"
                    width="45%"
                    height="500%"
                  ></v-skeleton-loader>
                  <h3 v-else class="card-title" v-if="total">{{ total }}</h3>
                </v-card-body>
              </v-card>
            </template>
            <template v-slot:default="{ isActive }" class="justify-content center-item">
              <v-card style="width: 50vw;">
                <v-card-title>
                  <v-row>
                    <v-col>
                      <span class="text-h5">Totals</span>
                    </v-col>
                    <v-col class="d-flex justify-end">
                      <v-btn icon @click="showTotalDetails = false">
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-title>
                <v-card-text>
                  <v-list>
                    <v-list-item v-for="(value, key) in totals" :key="key">
                      <v-list-item-content>
                        <b>{{ key }}</b>: {{ value }}
                      </v-list-item-content>
                      <v-divider></v-divider>
                    </v-list-item>
                  </v-list>
                </v-card-text>
              </v-card>
            </template>
          </v-dialog>
        </v-col>
        <v-col cols="12" md="6">
          <v-row class="ps-16">
            <v-dialog width="auto" scrollable>
              <template v-slot:activator="{ props: activatorProps }">
                <v-skeleton-loader
                  v-if="
                    loadingNewDataReady &&
                    parameters.teamMember.userName === undefined
                  "
                  type="text"
                  :width="`${100 / 2}vw`"
                  :height="`${100 / 22.6}vh`"
                ></v-skeleton-loader>
                <v-btn
                  id="getTeamMemberCampaignsDetails"
                  ref="getTeamMemberCampaignsDetails"
                  class="mt-4"
                  v-bind="activatorProps"
                  color="surface-variant"
                  :text="`${parameters.teamMember.name} have ${totalNbrOfCampaigns} campaigns for this period`"
                  variant="elevated"
                  v-else-if="!isRoleOther"
                ></v-btn>
                <v-btn
                  id="getTeamMemberCampaignsDetails"
                  ref="getTeamMemberCampaignsDetails"
                  class="mt-4"
                  v-bind="activatorProps"
                  color="surface-variant"
                  :text="`${parameters.teamMember.userName} have ${totalNbrOfCampaigns} campaigns for this period`"
                  variant="elevated"
                  v-else
                >
                </v-btn>
              </template>
              <template v-slot:default="{ isActive }">
                <v-card
                  :title="`${parameters.teamMember.userName === undefined ? parameters.teamMember.name: parameters.teamMember.userName} campaigns for this period`"
                  class="campaigns-details-wrapper d-flex flex-column align-center justify-center"
                >
                  <v-card-text style="height: 450px">
                    <v-col cols="12">
                      <v-row>
                        <v-col cols="9">
                          <v-card-item class="sticky">
                            <v-skeleton-loader
                              v-if="loadingNewDataReady"
                              type="text"
                              width="100%"
                              height="40px"
                            ></v-skeleton-loader>
                            <v-text-field
                              v-else
                              v-model="searchQuery"
                              prepend-inner-icon="mdi-magnify"
                              label="Search"
                              variant="outlined"
                              single-line
                              hide-details
                              class="mx-4"
                            >
                            </v-text-field>
                          </v-card-item>
                        </v-col>
                        <v-col cols="3">
                          <v-skeleton-loader
                            v-if="loadingNewDataReady"
                            type="text"
                            width="100%"
                            height="40px"
                          ></v-skeleton-loader>
                          <v-btn
                            v-else
                            :loading="isSmallExportDone"
                            class="mt-4"
                            @click="
                              csvExportCurrentUserCampaigns(
                                currentUserCampaigns,
                              )
                            "
                            color="surface-variant"
                            text="Export this table"
                            variant="flat"
                          ></v-btn>
                        </v-col>
                      </v-row>
                      <v-divider></v-divider>
                      <v-row>
                        <v-card-text>
                          <v-skeleton-loader
                            v-if="loadingNewDataReady"
                            type="text"
                            width="100%"
                            height="40px"
                          ></v-skeleton-loader>
                          <v-data-table-virtual
                            v-else
                            :headers="headersUserCampaigns"
                            :items="currentUserCampaigns"
                            :search="searchQuery"
                            fixed-header=""
                            :loading="tableDataReady"
                          >
                            <template v-slot:item.manDaysUsed="{ item }">
                              <v-chip
                                :color="
                                  getColorForTable(
                                    item.manDaysUsed,
                                    item.timeSpentOnCampaign,
                                  )
                                "
                              >
                                {{ item.manDaysUsed }}
                              </v-chip>
                            </template>
                            <template
                              v-slot:item.timeSpentOnCampaign="{ item }"
                            >
                              <v-chip
                                :color="
                                  getColorForTable(
                                    item.manDaysUsed,
                                    item.timeSpentOnCampaign,
                                  )
                                "
                              >
                                {{ item.timeSpentOnCampaign.toFixed(2) }}
                              </v-chip>
                            </template>
                            <v-divider></v-divider>
                            <template #bottom>
                              <v-data-table :items="footerObject">
                                <template #bottom>
                                </template>
                              </v-data-table>
                            </template>
                          </v-data-table-virtual>
                        </v-card-text>
                      </v-row>
                    </v-col>
                  </v-card-text>
                  <v-card-actions location="right">
                    <v-btn
                      icon="mdi-close"
                      @click="isActive.value = false"
                    ></v-btn>
                  </v-card-actions>
                </v-card>
              </template>
            </v-dialog>
          </v-row>
          <v-row class="ps-16">
            <v-btn
              :loading="isExportDone"
              id="exportAllTeamMembersCampaigns"
              ref="exportAllTeamMembersCampaigns"
              class="mt-5"
              color="surface-variant"
              text="Export all Team Members campaigns on this period"
              variant="elevated"
              @click="getExportForAllTeamMember()"
            >
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
      <div class="d-flex justify-content-center">
        <v-skeleton-loader
          v-if="loadingNewDataReady"
          type="ossein"
          class="skeleton-loader-chart"
        ></v-skeleton-loader>
        <div
          class="card"
          id="card-chart"
          v-else-if="!empty && !loadingNewDataReady"
        >
          <barChart :data="chartData" :key="barChartKey"></barChart>
        </div>
        <div class="card" id="card-chart" v-else>
          <h3 class="card-title">No Data to display</h3>
        </div>
      </div>
      <button class="btn btn-outline-primary" @click="csvExport(chart)">
        Download chart data
      </button>
    </div>
  </div>

  <!-- Modal -->
  <div
    class="modal fade"
    id="productModal"
    tabindex="-1"
    aria-labelledby="productModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-m">
      <div class="modal-content">
        <div class="modal-header">
          <h6 class="modal-title" id="exampleModalLabel">Totals</h6>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <ul class="list-group">
            <li
              class="list-group-item"
              v-for="(value, key) in totals"
              :key="key"
              style="list-style: none"
            >
              {{ key }}: {{ value }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</protected-pages-layout>
</template>

<script setup>
import Navbar from "../components/Navbar.vue";
import barChart from "../components/charts/TeamReportChart.vue";
import ExportModule from "../components/ExportModule.vue";
import {
  periods,
  breakdowns,
  billables,
  personalReportTypes,
} from "../assets/variables.js";
import { ref, onMounted, watch, nextTick, computed } from "vue";
import { storeToRefs } from "pinia";
import { useLeadReportStore } from "../stores/teamLeadReport.js";
import { useTeamStore } from "../stores/team";

const leadReportStore = useLeadReportStore();
const chartWidth = ref(800);
const chartHeight = ref(400);

const isRoleOther = computed(() => {
  let user = window.$cookies.get("user");
  return user.Role === "Other";
});

const {
  getTotal: total,
  getChart: chart,
  getParameters: parameters,
  getChartData: chartData,
  getBarChartKey: barChartKey,
  getEmpty: empty,
  getTotals: totals,
  getDetail: details,
  getFavoritesPages: favoritesPages,
  getTeamMembers: teamMembers,
  currentUserCampaigns,
  isExportDone,
} = storeToRefs(leadReportStore);

const teamStore = useTeamStore();

const {
  getReport,
  fetchTeamMembers,
  calculateTotals,
  csvExport,
  getExportForAllTeamMember,
  getReportForOtherRole,
} = leadReportStore;

const { getTeams: teams } = storeToRefs(teamStore);

const { fetchTeams } = teamStore;

const currentTeam = ref({});

let pageReady = ref(false);
let loadingNewDataReady = ref(true);
onMounted(async () => {
  let user = window.$cookies.get("user");
  if (user.Role === "Other") {
    await fetchTeams();
    // console.log("teams: ", teams.value);
    currentTeam.value = teams.value[0];
    // console.log("currentTeam: ", currentTeam.value);
    parameters.value.teamMember = teams.value[0].Members[0];
    let teamLeadeUserId = undefined;
    console.log("parameters.leadReportType: ", parameters.leadReportType);

    teams.value.forEach((team) => {
      // console.log("team: ", team);
      if (team.Members === undefined || team.Members === null) {
        return;
      }
      if (team.Members.length === 0) {
        return;
      }
      team.Members.forEach((member) => {
        // console.log("member: ", member);
        if (member.IsLead) {
          teamLeadeUserId = member.UserID;
        }
      });
    })

    // console.log("teamLeadeUserId: ", teamLeadeUserId);
    if (teamLeadeUserId === undefined) {
      pageReady.value = true;
      loadingNewDataReady.value = false;
    } else {
      await getReportForOtherRole(teamLeadeUserId);
    }
  } else {
    await fetchTeamMembers();
    await getReport();
  }
  pageReady.value = true;
  loadingNewDataReady.value = false;
});

const getColorForTable = (manDaysUsed, timeSpent) => {
  if (manDaysUsed === 0) {
    return "";
  } else if (manDaysUsed >= timeSpent) {
    return "success";
  } else {
    return "warning";
  }
};

const searchQuery = ref("");
let timeout;
watch(searchQuery, (newQuery) => {
  clearTimeout(timeout);
  timeout = setTimeout(() => {}, 500);
});

const headersUserCampaigns = [
  { title: "Campaign", key: "id", align: "center", sortable: true },
  { title: "Client Id", key: "clientId", align: "center", sortable: true },
  { title: "client Name", key: "clientName", align: "center", sortable: true },
  {
    title: "Man Days Used",
    key: "manDaysUsed",
    align: "center",
    sortable: true,
  },
  {
    title: "Complexity",
    key: "complexityOfTest",
    align: "center",
    sortable: true,
  },
  {
    title: "Time Spent On Campaign",
    key: "timeSpentOnCampaign",
    align: "center",
    sortable: true,
  },
  { title: "Date", key: "date", align: "center", sortable: true },
];

const reloadCurrUserCampaign = ref(0);

const dataChangement = async () => {
  loadingNewDataReady.value = true;
  reloadCurrUserCampaign.value += 1;
  if (isRoleOther.value) {
    let teamLeadeUserId = null;
    currentTeam.value.Members.forEach((member) => {
      // console.log("member: ", member);
      if (member.IsLead) {
        teamLeadeUserId = member.UserID;
      }
    });
    await getReportForOtherRole(teamLeadeUserId);
  } else {
    await getReport();
    adjustButtonSize();
  }
  loadingNewDataReady.value = false;
};


const totalNbrOfCampaigns = computed(() => {
  if (currentUserCampaigns.value === undefined) {
    return 0;
  } else {
    return currentUserCampaigns.value.length;
  }
});

const footerObject = computed(() => {
  let obj = {
    "Total": "Total",
    "Man-Days Used": currentUserCampaigns.value.reduce(
    (acc, curr) => acc + curr.manDaysUsed,
    0,
  ).toFixed(2),
    "Time Spent On Campaign": currentUserCampaigns.value.reduce(
    (acc, curr) => acc + curr.timeSpentOnCampaign,
    0,
  ).toFixed(2),
    "Time Spent On Billable Campaign": currentUserCampaigns.value
    .filter((item) => item.manDaysUsed > 0)
    .reduce((acc, curr) => acc + curr.timeSpentOnCampaign, 0).toFixed(2),
    "Time Spent On Offered Campaign": currentUserCampaigns.value
    .filter((item) => item.manDaysUsed === 0)
    .reduce((acc, curr) => acc + curr.timeSpentOnCampaign, 0).toFixed(2),
  };
  const array = [];
  array.push(obj);
  return array
});

const campaignsToDisplay = ref(currentUserCampaigns);
const isSmallExportDone = ref(false);

watch(campaignsToDisplay, (newVal) => {
  reloadCurrUserCampaign.value += 1;
});

const csvExportCurrentUserCampaigns = (data) => {
  isSmallExportDone.value = true;
  var result, columnDelimiter, lineDelimiter;
  columnDelimiter = ",";
  lineDelimiter = "\n";
  result = "";
  result +=
    "User Name, Campaign,Client Id,Client Name,Man Days Used,Complexity,Time Spent On Campaign,Date";
  result += lineDelimiter;
  data.forEach(function (item) {
    result += item.userName + columnDelimiter;
    result += item.id + columnDelimiter;
    result += item.clientId + columnDelimiter;
    result += item.clientName + columnDelimiter;
    result += item.manDaysUsed + columnDelimiter;
    result += item.complexityOfTest + columnDelimiter;
    result += item.timeSpentOnCampaign + columnDelimiter;
    result += item.date;
    result += lineDelimiter;
  });
  var csv = result;
  let today = new Date();
  var filename =
    "export_" +
    parameters.value.teamMember.name +
    "_campaigns_" +
    today +
    ".csv";
  filename = filename.replace(/\s/g, "_").replace(/[^a-zA-Z0-9_]/g, "");
  filename = filename || "export.csv";
  if (!csv.match(/^data:text\/csv/i)) {
    csv = "data:text/csv;charset=utf-8," + csv;
  }
  data = encodeURI(csv);
  let link = document.createElement("a");
  link.setAttribute("href", data);
  link.setAttribute("download", filename);
  link.click();
  isSmallExportDone.value = false;
};

function adjustButtonSize() {
  nextTick(() => {
    let button1 = document.getElementById("getTeamMemberCampaignsDetails");
    let button2 = document.getElementById("exportAllTeamMembersCampaigns");

    const button1Width = button1.offsetWidth;
    const button2Width = button2.offsetWidth;
    const buttonWidth =
      button1Width > button2Width ? button1Width : button2Width;
    button1.style.width = buttonWidth + "px";
    button2.style.width = buttonWidth + "px";

    const button1Height = button1.offsetHeight;
    const button2Height = button2.offsetHeight;
    const buttonHeight =
      button1Height > button2Height ? button1Height : button2Height;
    button1.style.height = buttonHeight + "px";
    button2.style.height = buttonHeight + "px";
  });
}

const showTotalDetails = ref(false);
</script>

<script>
import Navbar from "../components/Navbar.vue";
import barChart from "../components/charts/TeamReportChart.vue";
import ExportModule from "../components/ExportModule.vue";
import { defineComponent } from "vue";
export default defineComponent({
  name: "TeamLeadReport",
  components: {
    navbar: Navbar,
    barChart,
  },
});
</script>

<style lang="scss">
.wrapper {
  width: clamp(
    867px,
    calc(100vw * 0.8465),
    2166px
  );
  aspect-ratio: 1219/811;
  margin: 0 auto;
  position: relative;
}
.card {
  margin-top: 30px;
}

.group-header {
  color: #6c757d !important;
  font-weight: bolder;
  text-decoration: none;
  margin: 0px 13px;
  list-style-type: none;
  cursor: pointer;
}

.group-header:after {
  content: "";
  display: block;
  /* margin: auto; */
  height: 3px;
  width: 0px;
  background: transparent;
  transition: width 0.2s ease;
}

.group-header:hover:after {
  width: 120px;
  background: #fe938c;
}

h2 {
  text-align: center;
}

.entry-detail {
  text-align: left;
}

.table th {
  border-top: none !important;
}

.table td {
  border-top: none !important;
}

.bar-chart-parent {
  @media (min-width: 50px) {
    margin-top: 30px;
    height: 100%;
    width: 100%;
    overflow-x: scroll;
  }
  @media (min-width: 768px) {
    margin-top: 30px;
    width: 90vw;
    height: 50vh;
  }
}

.skeleton-loader-chart {
  @media (min-width: 50px) {
    margin-top: 30px;
    height: 100%;
    width: 100%;
    overflow-x: scroll;
  }
  @media (min-width: 768px) {
    width: 90vw;
    height: 50vh !important;
  }
}
</style>
